import { useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setNavigate } from '../utils/navigation';
import i18n from '../config/i18n';
import { parseLocalizedUrl } from '../config/route-translations';

const LANGUAGE_BEFORE_CARGO_KEY = 'navimagLanguageBeforeCargo';

const isCargoPath = pathname =>
  pathname === '/cargo' || pathname.startsWith('/cargo/');

// Keeps cargo in Spanish without leaving the rest of the site in that language.
// Storage is updated during render so child pages read Spanish before their effects run.
const syncCargoLanguageStorage = pathname => {
  const onCargo = isCargoPath(pathname);

  if (onCargo) {
    if (!sessionStorage.getItem(LANGUAGE_BEFORE_CARGO_KEY)) {
      sessionStorage.setItem(
        LANGUAGE_BEFORE_CARGO_KEY,
        localStorage.getItem('language') || 'es'
      );
    }
    if (localStorage.getItem('language') !== 'es') {
      localStorage.setItem('language', 'es');
    }
    return 'es';
  }

  const previous = sessionStorage.getItem(LANGUAGE_BEFORE_CARGO_KEY);
  if (!previous) return null;

  const { language: pathLanguage } = parseLocalizedUrl(pathname);
  const restored = pathLanguage || previous;
  if (localStorage.getItem('language') !== restored) {
    localStorage.setItem('language', restored);
  }
  return restored;
};

const NavigationProvider = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const languageToApply = syncCargoLanguageStorage(pathname);

  useLayoutEffect(() => {
    if (!isCargoPath(pathname)) {
      sessionStorage.removeItem(LANGUAGE_BEFORE_CARGO_KEY);
    }
    if (languageToApply && i18n.language !== languageToApply) {
      i18n.changeLanguage(languageToApply);
    }
  }, [pathname, languageToApply]);

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return children;
};

export default NavigationProvider;
